import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import * as R from 'ramda'
import { bufferFunction } from '$helper/functions/buffer-function'
import { request } from '$setup/ws'
import {
  GetStoryLists,
  StoryPeerInfo,
  reqGetStoryLists,
} from '@weblite/ts-action/story'
import { StoryRibbon } from './types'
import { storiesStorage } from './storage'

let isLoading = false
const setters: Dispatch<SetStateAction<boolean>>[] = []

export function setIsLoading(loading: boolean) {
  setters.forEach(setter => setter(isLoading))
  isLoading = loading
}

export function useIsLoadingNonSubscribedRibbons() {
  const [loading, setLoading] = useState(isLoading)

  useEffect(() => {
    setters.push(setLoading)

    return () => {
      const index = setters.findIndex(setter => setter === setLoading)
      if (index !== -1) setters.splice(index, 1)
    }
  }, [])

  return loading
}

export const getNonSubscribedRibbon = bufferFunction(
  async (peers: StoryPeerInfo[]) => {
    setIsLoading(true)
    const uniqPeers = R.uniqBy(peer => peer.peerId + peer.peerType, peers)

    const data = await request<GetStoryLists>(
      reqGetStoryLists({ peers: uniqPeers }),
    )
    if (data.error) {
      setIsLoading(false)
      return
    }

    const storyRibbons: StoryRibbon[] = uniqPeers.map(
      ({ peerId, peerType }) => {
        const ribbon = data.payload.storyLists.find(
          storyList =>
            storyList.peerId === peerId && storyList.peerType === peerType,
        )
        const lastStoryAt = ribbon?.lastStoryAt || new Date().toString()
        const stories = ribbon?.stories || []

        return {
          peerId,
          peerType,
          stories,
          nonSubscribed: true,
          lastStoryAt,
        }
      },
    )

    storiesStorage.setServerStoryRibbonsData(storyRibbons)
    setIsLoading(false)
  },
  1000,
)
